import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import DashboardShell from "@/components/nav/DashboardShell";
import { UserPlus, ArrowRight } from "lucide-react";

export default function Employees() {
  const [emps, setEmps] = useState([]);

  useEffect(() => {
    api.get("/customer-employees").then(({data}) => setEmps(data)).catch(() => {});
  }, []);

  return (
    <DashboardShell>
      <div className="flex items-end justify-between mb-10 flex-wrap gap-4">
        <div>
          <div className="brand-eyebrow mb-4">TEAM</div>
          <h1 className="brand-headline text-4xl md:text-6xl">My Employees.</h1>
        </div>
        <Link data-testid="hire-another" to="/pricing" className="btn-gold text-sm px-5 py-3"><UserPlus size={16} /> Hire another employee</Link>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {emps.map(e => (
          <Link key={e.id} to={`/employees/${e.id}`} data-testid={`emp-card-${e.ai_employee_slug}`} className="border border-line p-8 hover:border-gold transition-colors">
            <div className="flex items-center justify-between">
              <div className="brand-eyebrow">{e.ai_employee_slug.replace(/-/g,' ').toUpperCase()}</div>
              <div className="text-[11px] tracking-widest text-smoke flex items-center gap-2">
                <span className={`dot ${e.status==='Working'?'dot-green':e.status==='Paused'?'dot-gray':e.status==='Needs Attention'?'dot-red':'dot-amber'}`} />{e.status}
              </div>
            </div>
            <div className="brand-headline text-4xl mt-6">{e.display_name}</div>
            <div className="mt-6 grid grid-cols-3 gap-4 text-center">
              <Metric label="Today" value={e.tasks_today ?? 0} />
              <Metric label="Waiting" value={e.waiting_approval ?? 0} />
              <Metric label="Done" value={e.tasks_completed ?? 0} />
            </div>
            <div className="mt-8 text-smoke text-xs">
              Last task: {e.last_task_at ? new Date(e.last_task_at).toLocaleString() : "—"}
            </div>
            <div className="mt-6 flex items-center gap-2 text-gold text-sm">Open command center <ArrowRight size={14} /></div>
          </Link>
        ))}
        {emps.length === 0 && (
          <div className="col-span-full border border-line p-10 text-center text-smoke">
            No employees yet. <Link to="/pricing" className="text-gold hover:underline">Hire your first →</Link>
          </div>
        )}
      </div>
    </DashboardShell>
  );
}

function Metric({ label, value }) {
  return (
    <div>
      <div className="brand-headline text-3xl">{value}</div>
      <div className="text-[10px] tracking-widest text-smoke mt-1">{label.toUpperCase()}</div>
    </div>
  );
}
